import React from "react";
import { ReactComponent as BatteryIcon } from "../../../assets/status/battery_good.svg";
import { ReactComponent as BatteryLowIcon } from "../../../assets/status/battery_low.svg";
import { ReactComponent as BatteryWarningIcon } from "../../../assets/status/battery_warning.svg";
import I18nText from "../../../elements/I18nText";

const BatteryIndicator = ({ charge }) => {
  const value = Math.max(0, Math.min(100, Number(charge ?? 0)));

  let icon = <BatteryIcon />;
  let fillText = "devices.status.battery.normal";
  if (value < 60) {
    icon = <BatteryLowIcon />;
    fillText = "devices.status.battery.low";
  } else if (value <= 70) {
    icon = <BatteryWarningIcon />;
    fillText = "devices.status.battery.warning";
  }

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      {icon && <span style={{ width: 24, height: 24 }}>{icon}</span>}
      <span>
        <I18nText>{fillText}</I18nText>
      </span>
    </span>
  );
};
export default BatteryIndicator;
